(function () {
  var el = document.getElementById('pf-pim-data');
  var root = document.getElementById('pf-pim');
  if (!el || !root) return;
  var data; try { data = JSON.parse(el.textContent); } catch (e) { return; }

  var msgs = root.querySelector('#pf-pim-msgs');
  var chipsWrap = root.querySelector('#pf-pim-chips');
  var launcher = root.querySelector('.pf-pim__launcher');
  var teaser = root.querySelector('.pf-pim__teaser');
  var panel = root.querySelector('.pf-pim__panel');
  var closeBtn = root.querySelector('.pf-pim__close');
  var lastFocus = null;
  // Extra openers outside the corner launcher (header 768–1399 px, mobile tab bar < 768 px); shown only when Pim exists.
  var triggers = document.querySelectorAll('[data-pf-pim-open]');
  document.documentElement.classList.add('pf-has-pim');
  var opened = false, started = false;
  // Paneel start gesloten → uit de tab-volgorde halen (pointer-events:none verbergt
  // alleen de muis, niet het toetsenbord).
  if(panel && 'inert' in HTMLElement.prototype){ panel.inert = true; }

  var flowsById = {}; (data.flows || []).forEach(function (f) { flowsById[f.id] = f; });
  var kbById = {};    (data.kb || []).forEach(function (k) { kbById[k.id] = k; });

  function esc(s){ return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }
  function linkify(t){
    // Alleen ECHTE storefront-paden linken (/collections/… of /pages/…), hoofdletter-
    // gevoelig. Voorkomt dat losse slash-reeksen als '4G/5G' een dode link /5G worden.
    return esc(t).replace(/(\/(?:collections|pages)\/[a-z0-9\-\/]*[a-z0-9])/g, function(u){ return '<a href="'+u+'">bekijk &rarr;</a>'; });
  }
  function down(){ msgs.scrollTop = msgs.scrollHeight; }
  function bot(html){ var d=document.createElement('div'); d.className='pf-pim__msg pf-pim__msg--bot'; d.innerHTML=html; msgs.appendChild(d); down(); }
  function usr(t){ var d=document.createElement('div'); d.className='pf-pim__msg pf-pim__msg--user'; d.textContent=t; msgs.appendChild(d); down(); }
  function typing(cb){ var d=document.createElement('div'); d.className='pf-pim__msg pf-pim__msg--bot pf-pim__typing'; d.innerHTML='<span></span><span></span><span></span>'; msgs.appendChild(d); down(); setTimeout(function(){ d.remove(); cb(); }, 480); }

  function renderChips(options){
    chipsWrap.innerHTML='';
    options.forEach(function(o){
      var b=document.createElement('button'); b.type='button'; b.className='pf-pim__chip'; b.textContent=o.label;
      b.addEventListener('click', function(){ handle(o); });
      chipsWrap.appendChild(b);
    });
  }
  function homeChips(){
    renderChips((data.quickChips||[]).map(function(c){
      var isKb = c.target.indexOf('kb:')===0;
      return { label:c.label, type: isKb?'kb':'flow', value: isKb?c.target.slice(3):c.target };
    }));
  }
  function afterChips(){
    renderChips([
      {label:'Vergelijk een ander model', type:'flow', value:'iphone-budget'},
      {label:'Past hier een accessoire bij?', type:'flow', value:'accessoire-start'},
      {label:'Een andere vraag', type:'flow', value:'service-start'},
      {label:'Bekijk alle iPhones', type:'link', value:'/collections/refurbished-iphones'},
      {label:'↺ Opnieuw beginnen', type:'restart', value:''}
    ]);
  }
  function handle(o){
    usr(o.label); chipsWrap.innerHTML='';
    if(o.type==='flow'){ var f=flowsById[o.value]; typing(function(){ bot(f?linkify(f.message):'Daar weet ik even niets over.'); if(f&&f.options&&f.options.length) renderChips(f.options); else afterChips(); }); }
    else if(o.type==='kb'){ var k=kbById[o.value]; typing(function(){ bot(k?('<strong>'+esc(k.q)+'</strong><br>'+linkify(k.a)):'Daar kom ik zo op terug.'); afterChips(); }); }
    else if(o.type==='message'){ typing(function(){ bot(linkify(o.value)); afterChips(); }); }
    else if(o.type==='link'){ window.location.href=o.value; }
    else if(o.type==='restart'){ start(true); }
    else { typing(function(){ bot('Hmm, daar heb ik even geen kant-en-klaar antwoord op. Kies hieronder verder of begin opnieuw.'); afterChips(); }); }
  }
  function start(force){ if(started && !force) return; started=true; msgs.innerHTML=''; bot(linkify(data.openerMessage||'Hoi! Hoe kan ik je helpen?')); homeChips(); }

  function focusables(){
    if(!panel) return [];
    var nodes = panel.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), [tabindex]:not([tabindex="-1"])');
    var out = [];
    for(var i=0;i<nodes.length;i++){ if(nodes[i].offsetParent !== null) out.push(nodes[i]); }
    return out;
  }
  function open(){
    if(opened) return; opened=true;
    lastFocus = document.activeElement;
    root.classList.add('is-open');
    // Beeldvullend op mobiel → achtergrond niet mee laten scrollen.
    if(window.matchMedia && window.matchMedia('(max-width: 640px)').matches){ document.body.style.overflow = 'hidden'; }
    root.querySelectorAll('.pf-pim__teaser').forEach(function(t){ t.style.display='none'; });
    launcher.setAttribute('aria-expanded','true');
    triggers.forEach(function(t){ t.setAttribute('aria-expanded','true'); });
    if(panel && 'inert' in HTMLElement.prototype){ panel.inert = false; }
    start();
    if(closeBtn){ try{ closeBtn.focus({preventScroll:true}); }catch(e){ closeBtn.focus(); } }
  }
  function close(){
    if(!opened) return; opened=false;
    root.classList.remove('is-open');
    document.body.style.overflow = '';
    launcher.setAttribute('aria-expanded','false');
    triggers.forEach(function(t){ t.setAttribute('aria-expanded','false'); });
    if(panel && 'inert' in HTMLElement.prototype){ panel.inert = true; }
    var back = (lastFocus && lastFocus.focus && document.contains(lastFocus) && lastFocus.offsetParent !== null) ? lastFocus : launcher;
    if(back){ try{ back.focus({preventScroll:true}); }catch(e){ try{ back.focus(); }catch(_){} } }
  }

  launcher.addEventListener('click', function(){ opened?close():open(); });
  triggers.forEach(function(t){ t.addEventListener('click', function(e){ e.preventDefault(); if(opened){ close(); return; } open(); lastFocus = t; }); });
  if(closeBtn) closeBtn.addEventListener('click', close);
  // Persistente snelkoppelingen (altijd bereikbaar, ongeacht waar je in het gesprek zit)
  root.querySelectorAll('.pf-pim__qbtn').forEach(function(b){
    b.addEventListener('click', function(){
      var t = b.getAttribute('data-act');
      if(t === 'restart'){ start(true); return; }
      handle({ label: b.textContent.trim(), type: t, value: b.getAttribute('data-val') });
    });
  });
  // Toetsenbord: Escape sluit; Tab/Shift+Tab blijft binnen het paneel (focus-trap) zolang open.
  document.addEventListener('keydown', function(e){
    if(!opened) return;
    if(e.key==='Escape'){ e.preventDefault(); close(); return; }
    if(e.key==='Tab'){
      var list = focusables();
      if(!list.length) return;
      var first = list[0], last = list[list.length-1];
      if(e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
      else if(!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
    }
  });
  // Globale hook: open Pim vanaf elke "hulp nodig?"-knop via onclick="pfPimOpen()" of een 'pf:pim:open'-event
  window.pfPimOpen = open;
  // Open Pim en spring direct naar een flow (voor de hulppagina-kaarten).
  window.pfPimStart = function (flowId) {
    if (!opened) open();
    if (!flowId) return;
    var f = flowsById[flowId];
    if (!f) return;
    chipsWrap.innerHTML = '';
    typing(function () {
      bot(linkify(f.message));
      if (f.options && f.options.length) renderChips(f.options); else afterChips();
    });
  };
  document.addEventListener('pf:pim:open', open);
  document.addEventListener('pf:pim:start', function (e) { window.pfPimStart(e && e.detail); });
  var teasers = [].slice.call(root.querySelectorAll('.pf-pim__teaser'));
  function hideTeasers(){ teasers.forEach(function(t){ t.style.display='none'; }); }
  teasers.forEach(function(t){
    t.addEventListener('click', open);
    t.addEventListener('keydown', function(e){ if(e.target===t && (e.key==='Enter' || e.key===' ')){ e.preventDefault(); open(); } });
    var x = t.querySelector('.pf-pim__teaser-x');
    if(x) x.addEventListener('click', function(e){ e.stopPropagation(); hideTeasers(); try{sessionStorage.setItem('pfPimT','1');}catch(_){} });
  });
  try {
    if(!sessionStorage.getItem('pfPimT')){
      /* Pim blijft standaard rustig ingeklapt; geen automatische teaser. */
    } else { hideTeasers(); }
  } catch(_){}
})();
